import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import stylesThankYou from "../ThankYouPage/styles/ThankYouPage.module.css";
import { useSelector } from "react-redux";
import { ADMIN_ROLE } from "@constants";
import { Button } from "react-bootstrap";

const Error404Page = () => {
  const { login } = useSelector((state) => state.auth);
  return (
    // <div className={clsx(stylesThankYou.container)}>
    <div className={clsx(stylesThankYou.container)}>
      <span className={clsx(stylesThankYou.mainText)}>404</span>
      <div className={clsx(stylesThankYou.detailText)}>
        <span className={clsx(stylesThankYou.notiText)}>
          The page you were looking for could not be found.
        </span>
        <Link to={login.role === ADMIN_ROLE ? "/admin" : "/"} replace={true}>
          <Button style={{ fontWeight: "600" }}>Go To Homepage</Button>
        </Link>
      </div>
    </div>
  );
};

/* required: display name */
Error404Page.displayName = "Error404Page";

/* required: props types */
Error404Page.propTypes = {};

/* required: default props */
Error404Page.defaultProps = {};

export { Error404Page };
